import React from 'react';
import AgreementSentence from './AgreementSentence';

export default (props) => {
  if (props.children) {
    if (!props.completed && props.type === 'create') {
      return (
        <p
          className={`${props.section.replace(/\s/g, '')} ${
            props.section === props.tabName && 'block-selected'
          }`}
          dangerouslySetInnerHTML={{ __html: props.children }}
        />
      );
    } else {
      let sectionContent = props.children.replace(new RegExp('<u>', 'g'), '');
      sectionContent = sectionContent.replace(new RegExp('</u>', 'g'), '');
      sectionContent = sectionContent.replace(
        new RegExp('<br /><br />', 'g'),
        '.  '
      );
      sectionContent = sectionContent.replace(new RegExp('<br />', 'g'), '.  ');

      let sentences = [];
      if (!props.children.includes('<h5>')) {
        sentences = sectionContent.split('.  ');
      } else {
        sentences = [sectionContent];
      }

      const editable = props.type === 'deal-edit' && props.editable;

      if (props.section === 'Payments' || props.section === 'Composition') {
        return (
          <div
            className={`agreement-section ${!editable && 'mb4'} ${
              props.section === props.tabName && 'block-selected'
            }`}
          >
            <div className={props.section.replace(/\s/g, '')}>
              {sentences.map((sentence, i) => {
                return (
                  <AgreementSentence {...props} key={i} index={i}>
                    {sentence.trim()}
                  </AgreementSentence>
                );
              })}
            </div>
          </div>
        );
      } else {
        return (
          <div
            className={`agreement-section ${!editable && 'mb4'} ${
              props.section === props.tabName && 'block-selected'
            }`}
          >
            <div className={props.section.replace(/\s/g, '')}>
              {sentences.map((sentence, i) => {
                if (sentence && sentence.trim() !== '') {
                  let content = sentence.trim();
                  if (!props.children.includes('<h5>')) {
                    if (!content.endsWith('.')) {
                      content += '.';
                    }
                  }
                  return (
                    <AgreementSentence {...props} key={i} index={i}>
                      {content}
                    </AgreementSentence>
                  );
                } else {
                  return null;
                }
              })}
            </div>
          </div>
        );
      }
    }
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// src/components/Agreements/AgreementSection.jsx